import { useTranslation } from 'react-i18n-lite'
import useWorkflow from './useWorkflow'
import { useAppSelector } from 'state/store'
import { useCallback } from 'react'

const useDataFromWorkflow = () => {
  const { t } = useTranslation()
  const { workflowUuid } = useAppSelector((state) => state.interactionModel)

  const { workflow } = useWorkflow({ t, workflowUuid })

  const processState = workflow?.execution_state

  const getVariableFromProcessState = useCallback(
    (identifier: string) => {
      return processState?.data_container?.[identifier]
    },
    [processState]
  )

  return { getVariableFromProcessState }
}

export default useDataFromWorkflow
